import $ from 'jquery';

$(document).ready(function() {
  // tab-sorted articles (all, follows, favorite)

  $('.subscription-tab__selection-tab-item').click(function() {
    var tabId = $(this).attr('data-tab');

    $('.subscription-tab__selection-tab-item').removeClass('current');
    $('.tab-content-articles').removeClass('current');

    $(this).addClass('current');
    $('#' + tabId).addClass('current');
  });

  // menu-nav show
  $('.menu-nav-categories__row').click(function() {
    $(this)
      .find('.menu-nav-categories__link')
      .toggleClass('menu-nav-active');
    $(this)
      .siblings('.menu-nav-categories__sub-menu')
      .toggleClass('menu-nav-categories__sub-menu-show');
    $(this)
      .find('.icon-menu-nav-vector')
      .toggleClass('vector-active');
    $(this)
      .parent()
      .siblings()
      .find('.menu-nav-categories__sub-menu')
      .removeClass('menu-nav-categories__sub-menu-show');
    $(this)
      .parent()
      .siblings()
      .find('.menu-nav-categories__link')
      .removeClass('menu-nav-active');
    $(this)
      .parent()
      .siblings()
      .find('.icon-menu-nav-vector')
      .removeClass('vector-active');
  });

  // menu-nav show mobile version
  $('.menu-nav-mob__link').click(function() {
    $(this).toggleClass('menu-nav-vector-up');
    $(this)
      .find('.icon-menu-nav-vector')
      .toggleClass('vector-active');
    $('.menu-nav-wrapper')
      .fadeToggle()
      .toggleClass('menu-nav-show');
  });

  // non auth user cant copy text on articles
  if (!$('body').hasClass('logged-in') && $('.articles-content').length > 0) {
    $('.articles-content').attr({
      oncopy: `$.fancybox.open({
            src: '#needRegistration-window',
            closeExisting: true,
            smallBtn: false,
            toolbar: false,
            touch: false,
          });
          return false;`
    });
  }
});
